import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsuarioFinalProfileGuard } from './guards/usuario-final-profile.guard';
import { MpvProfileGuard } from './guards/mpv-profile.guard';
import { SignedGuard } from './guards/signed.guard';
import { MesaDePartesProfileGuard } from './guards/mesa-de-partes-profile.guard copy';
import { ProfileFrameboardComponent } from './Components/profile-frameboard/profile-frameboard.component';
import { AdmProfileGuard } from './guards/adm-profile.guard';
import { DigitalizadorProfileGuard } from './guards/digitalizadorProfileGuard';
import { ControlCalidadProfileGuard } from './guards/control-calidad-profile.guard';
import {DespachoProfileGuard} from './guards/despachoProfileGuard';
import {FedatarioProfileGuard} from './guards/fedatarioProfileGuard';
import {ArchivoCentralProfileGuard} from "./guards/archivo-central-profile.guard";
import {SoporteOtiProfileGuard} from "./guards/soporte-oti-profile.guard";

const routes: Routes = [
  {
    path: `visor/:uuid`,
    loadChildren: () => import('./@pages/visor/visor.module').then(m => m.VisorModule)
  },
  {
    path: `visor-movil/:uuid`,
    loadChildren: () => import('./@pages/visor-movil/visor-movil.module').then(m => m.VisorMovilModule)
  },
  {
    path: `login`,
    loadChildren: () => import('./@pages/login/login.module').then(m => m.LoginModule),
    canActivate: [SignedGuard]
  },
  {
    path: `usuario-final`,
    loadChildren: () => import('./@pages/usuario-final/usuario-final.module').then(m => m.OefaModule),
    canActivate: [UsuarioFinalProfileGuard]
  },
  {
    path: `mesa-de-partes`,
    loadChildren: () => import('./@pages/mesa-de-partes/mesa-de-partes.module').then(m => m.MesaDePartesModule),
    canActivate: [MesaDePartesProfileGuard]
  },
  {
    path: `mpv`,
    loadChildren: () => import('./@pages/mpv/mpv.module').then(m => m.MpvModule),
    canActivate: [MpvProfileGuard]
  },
  {
    path: 'busqueda-avanzada',
    loadChildren: () => import('./@pages/busqueda/busqueda.module').then(m => m.BusquedaModule),
  },
  {
    path: 'administrador',
    canActivate: [AdmProfileGuard],
    loadChildren: () => import('./@pages/administrador/administrador.module').then(m => m.AdministradorModule),
  },{
    path: 'archivoCentral',
    canActivate: [ArchivoCentralProfileGuard],
    loadChildren: () => import('./@pages/archivo-central/archivo-central.module').then(m => m.ArchivoCentralModule),
  },
  {
    path: 'digitalizacion',
    canActivate: [DigitalizadorProfileGuard],
    loadChildren: () => import('./@pages/digitalizacion/digitalizacion.module').then(m => m.DigitalizacionModule),
  },
   {
    path: 'control-calidad',
    canActivate: [ControlCalidadProfileGuard],
    loadChildren: () => import('./@pages/control-calidad/control-calidad.module').then(m => m.ControlCalidadModule),
  },
  {
   path: 'despacho',
   canActivate: [DespachoProfileGuard],
   loadChildren: () => import('./@pages/despacho/despacho.module').then(m => m.DespachoModule),
  },
  {
    path: 'soporte-oti',
    canActivate: [SoporteOtiProfileGuard],
    loadChildren: () => import('./@pages/soporte-oti/soporte-oti.module').then(m => m.SoporteOtiModule),
  },
  {
   path: 'fedatario',
   /*canActivate: [FedatarioProfileGuard],*/
   loadChildren: () => import('./@pages/fedatario/fedatario.module').then(m => m.FedatarioModule),
  },
  {
    path: 'mantenimiento',
    loadChildren: () => import('./@pages/mantenimiento/mantenimiento.module').then(m => m.MantenimientoModule),
  },
  {
    path: `consultarCUO/:cuo`,
    loadChildren: () => import('./@pages/consulta-cuo/consulta-cuo-module').then(m => m.ConsultaCuoModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
